import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DollarSign, User } from 'lucide-react';

export default function DealCard({ deal, onClick, isDragOverlay = false }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: deal.id,
    data: { type: 'deal', deal },
    disabled: isDragOverlay,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
  };

  const formattedValue = deal.value != null
    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(deal.value)
    : null;

  return (
    <div
      ref={!isDragOverlay ? setNodeRef : undefined}
      {...(!isDragOverlay ? attributes : {})}
      {...(!isDragOverlay ? listeners : {})}
      onClick={onClick}
      className={`
        bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700
        p-3 cursor-grab active:cursor-grabbing hover:border-gray-300 dark:hover:border-gray-600
        transition-colors shadow-sm hover:shadow
        ${isDragOverlay ? 'shadow-lg ring-2 ring-brand-500/20' : ''}
      `}
      style={{
        ...(!isDragOverlay ? style : {}),
        borderLeftWidth: '3px',
        borderLeftColor: deal.stage_color || '#6B7280',
      }}
    >
      <div className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1.5 line-clamp-2">
        {deal.name}
      </div>

      {formattedValue && (
        <div className="flex items-center gap-1 text-xs text-gray-600 dark:text-gray-400 mb-1.5">
          <DollarSign className="w-3 h-3" />
          <span className="font-medium">{formattedValue}</span>
        </div>
      )}

      <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
        {deal.company_name && (
          <span className="truncate max-w-[60%]">{deal.company_name}</span>
        )}
        {deal.owner_name && (
          <div className="flex items-center gap-1 shrink-0">
            <User className="w-3 h-3" />
            <span className="truncate max-w-[80px]">{deal.owner_name}</span>
          </div>
        )}
      </div>
    </div>
  );
}
